module.exports = __webpack_public_path__ + "img/index_bg2.ce13c157.png";